/**
 * Home component
 *
 * The section at the top of the page to display image of your
 * choice, name and title that describes your career focus.
 */

import React from "react";
import arrowSvg from "../images/down-arrow.svg";
import PropTypes from "prop-types"; // Import the PropTypes module

/**
 * Home background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that
 * represents what you see in that image.
 *
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/engie-background.jpg";

const imageAltText = "Home background";

const Home = ({ name, title }) => {
  return (
    <section id="home" className="min-height">
      <img className="background" src={image} alt="" />
      <div
        style={{
          position: "absolute",
          top: "5rem",
          left: "2rem",
          width: "17rem",
        }}
      >
        <h1 style={{ fontSize: "calc(4rem + 4vw)" }}>{name}</h1>
        <h2 style={{ fontSize: "calc(2rem + 0.5vw)" }}>{title}</h2>
      </div>
      <div
        style={{ position: "absolute", bottom: "3rem", left: "50%", transform: "translateX(-50%)" }}
      >
        <img
          src={arrowSvg}
          style={{
            height: "3rem",
            width: "3rem",
            animation: "bounce 2s infinite",
          }}
          alt={imageAltText}
        />
      </div>
    </section>
  );
};

Home.defaultProps = {
  name: "",
  title: "",
};

Home.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Home;
